import useErrorField from '@package/hooks/src/useErrorField';

import Select from '../Select';

import { FromSelectProps } from './types';

const FormSelect = (props: FromSelectProps) => {
  const { field, form, options, onChangeCallback, ...rest } = props;

  const error = useErrorField(form.errors[field.name] as string, form.touched[field.name] as boolean);

  const handleChange = (value: any) => {
    form.setFieldValue(field.name, value);

    if (onChangeCallback) {
      onChangeCallback(value);
    }
  };

  return <Select {...field} {...error} options={options} onChange={handleChange} {...rest} />;
};

export default FormSelect;
